import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: '133',
		isIos: 1,   //判断是否是ios
		clientType: 1,  //客户端类型 1ios， 2安卓， 3h5	
		versionData: {
			platform: 'IOS',
			market: 'APPSTORE',
			versionNumber: '1.2.0',
		},
    },
    mutations: {
        upHead(state, url) {
            state.head = url
        },
		setToken(state, n) {
			state.token = n
		}
    },
})



export default store



// WEBPACK FOOTER //
// ./src/store/store.js